<template>
  <div class="sendTableList">
    <el-table
    class="fine-scroll-bar"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      :height="tableData.length==0?'120px':'300px'"
      >
        <!-- <template slot="empty">
          <div class="emptycontent">
            <div class="emptycontentimg">
              <img src="@/assets/image/common/mailnoData.png" alt="">
            </div>
            <div class="emptyText">
              暂无数据
            </div>
          </div>
        </template> -->
        <!-- 姓名 -->
      <el-table-column prop="name" :label="'姓名'">
        <template slot-scope="scope">
          <div>
            {{scope.row.contactName| noText}}
          </div>
        </template>
      </el-table-column>
      <!-- 邮箱 -->
      <el-table-column prop="email" :label="'邮箱'">
        <template slot-scope="scope">
          <div>
           {{scope.row.email| noText}}
          </div>
        </template>
      </el-table-column>
      <!-- 公司名称 -->
      <el-table-column prop="companyName" :label="'公司名称'">
        <template slot-scope="scope">
          <div>
            {{scope.row.companyName| noText}}
          </div>
        </template>
      </el-table-column>
      <!-- 职位 -->
      <el-table-column prop="alay" :label="'职务'">
        <template slot-scope="scope">
          <div>
            {{scope.row.title| noText}}
          </div>
        </template>
      </el-table-column>
      <!-- 行业 -->
      <el-table-column prop="industry" :label="'行业'">
        <template slot-scope="scope">
          <div v-if="scope.row.industry.length>0">
            <div v-for="(item,index) in scope.row.industry" :key="index">
              {{item}}
            </div>
          </div>
          <div v-else>---</div>
        </template>
      </el-table-column>
      <!-- 地区 -->
      <el-table-column prop="alay" :label="'地区'">
        <template slot-scope="scope">
          <div>
            {{areaFmater(scope.row.city,scope.row.state,scope.row.country)}}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {imgRes} from "@/utils/config"
export default {
  props:{
    tableData:{
      type:Array,
      default:[]
    },
  },
  data(){
    return{
       imgRes:imgRes,
    }
  },
  methods:{
    // 区域处理
    areaFmater(cityStr,stateStr,countryStr){
      let item=[]
      if(cityStr){
        item.push(cityStr)
      }
      if(stateStr){
        item.push(stateStr)
      }
      if(countryStr){
        item.push(countryStr)
      }
      return item.length>0?item.join():'---'
    },
  }
}
</script>

<style lang="scss" scoped>
.sendTableList{
  margin-top: 16px;
}
.emptycontent{
  .emptycontentimg{
    width: 166.5px;
    height: 120px;
    margin: 0 auto;
    margin-top: 32px;
    img{
      width: 100%;
      height: 100%;
    }
    // margin-bottom: 200px;
  }
  .emptyText{
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #4F5D78;
    line-height: 20px;
    margin-bottom: 32px;
  }
}

::v-deep .fine-scroll-bar {
    .el-table__body-wrapper{
    scrollbar-width: thin !important;//滚动条变细，为none时隐藏滚动条
    // 更改滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: hsla(0, 0%, 53%, 0.4);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: hsla(0, 0%, 53%, 0.1);
    }
  }
}
</style>